import { type ProfileIdentifier, VerticalType } from '@rma/generic/domain/types';
import type { SelectionShape } from '@rma/public/generic/domain/types';
import type { MapMarkerType } from './map-marker-type';

export type LocationType = 'Locality' | 'Neighbourhood' | 'City' | 'County' | 'State' | 'Country' | 'Agency' | 'Team';

// the company started capturing sales data in 2014, so nothing exists before it
export const SALES_HISTORY_FROM = new Date(2014, 1, 1);

export interface MapRequest {
  markerType: MapMarkerType;
  locationType?: LocationType;
  locationId?: number;
  excludeAddressCode?: string;
  from?: Date;
  verticalType: VerticalType;
  profileIdentifiers?: ProfileIdentifier[];
  shape?: SelectionShape;
  groupingThresholdDegrees?: number;
  take?: number;
  bedroomsMin?: number;
  bedroomsMax?: number;
  bathroomsMin?: number;
  bathroomsMax?: number;
  carparksMin?: number;
  carparksMax?: number;
  priceMin?: number;
  priceMax?: number;
  // a wire DTO: the server accepts the property type names as strings
  propertyTypes?: string[];
}
